/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import * as moment from 'moment';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import EmployeeComponent from './employee.Component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
import { emailValidation, isTwoObjectSame } from '../../services/utility';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class Employee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeList: [],
            employeeStatus: "active",
            isEditEmployee: false,
            isEditAssignDevices: false,
            isManuallyAddedEmployee: false,
            isAddEmployee: false,
            isSaveBtnDisabled: false,
            selectedEmployeeDetails: { hireDate: null },
            searchDeviceText: "",
            searchEmployeeText: "",
            searchProjectText: "",
            searchDivisionText: "",
            pagination: this.getPagination(),
            employeeStatusOptions: this.getEmployeeStatusOptions(),
            employeeDivisions: [],
            selectedEmpProjectAndDivision: { projectNumbers: [], divisions: [] },

            assignedDevicesIntheMainPage: [],

            // UNASSIGNED
            unAssignedDevicesInTheDeviceModal: [],
            selectedUnAssignedDevicesMap: new Map(),
            selectAllUnAssignedDevices: false,

            // ASSIGNED
            assignedDevicesInTheDeviceModal: [],
            selectedAssignedDevicesMap: new Map(),
            selectAllAssignedDevices: false,
        };

        // global
        this.allEmployees = [];
        this.allDevices = [];
        this.currentlySelectedEmployee = null;
        this.extraTake = 50;
        this.assignedDevicesSkip = Constants.DEFAULT_SKIP;
        this.assignedDevicesTake = Constants.DEFAULT_TAKE;

        // reset
        this.currentlySelectedEmployeeDetails = null;
        this.currentAssignedDevicesTake = Constants.DEFAULT_TAKE;
        this.currentUnAssignedDevicesTake = Constants.DEFAULT_TAKE;
        this.fetchedAssignedDevices = false;
        this.fetchedUnAssignedDevices = false;
        this.tempAssignedDeviceIds = [];
        this.searchUnAssignDeviceText = "";
        this.searchAssignedDeviceText = "";
        this.deviceUnAssignTrackMap = new Map();
        this.deviceAssignTrackMap = new Map();
        this.originalAssignedDevicesMap = new Map();
        this.allUnAssignedDeviceWithoutSlicing = new Map();
        this.allAssignedDeviceWithoutSlicing = new Map();
        // reset

        // abortController
        this.assignUnAssignAbortController = new AbortController();
        // abortController

        this.deviceNameSearchDebounce = null;
        this.projectNameSearchDebounce = null;
        this.divisionNameSearchDebounce = null;
        this.assignDeviceSearchDebounce = null;
        this.unAssignDeviceSearchDebounce = null;
        this.employeeSearchDebounce = null;
    }

    componentDidMount() {
        this.getAllEmployees(true);
        this.getDivisionDetails();
    }

    componentWillUnmount() {
        clearTimeout(this.deviceNameSearchDebounce);
        clearTimeout(this.projectNameSearchDebounce);
        clearTimeout(this.divisionNameSearchDebounce);
        clearTimeout(this.assignDeviceSearchDebounce);
        clearTimeout(this.unAssignDeviceSearchDebounce);
        clearTimeout(this.employeeSearchDebounce);

        if (this.assignUnAssignAbortController) {
            this.assignUnAssignAbortController.abort();
        }
    }

    clone(data) {
        return JSON.parse(JSON.stringify(data ?? []));
    }

    getStatusOptions() {
        return [{ option: "Active", value: 'active' }, { option: "InActive", value: 'inActive' }];
    }

    getEmployeeStatusOptions() {
        return [{ key: 'Active', text: 'Active', value: 'active' }, { key: 'InActive', text: 'InActive', value: 'inactive' }];
    }

    getPagination() {
        return {
            activePage: 1,
            totalCount: 0,
            skip: Constants.DEFAULT_SKIP,
            take: Constants.DEFAULT_TAKE
        };
    }

    fetchNext(type) {
        switch (type) {
            case Constants.UNASSIGN_DEVICE:
                if (this.currentUnAssignedDevicesTake >= this.allDevices.length) return;
                this.currentUnAssignedDevicesTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterUnAssignedDevices();
                break;
            case Constants.ASSIGN_DEVICE:
                if (this.currentAssignedDevicesTake >= this.allDevices.length) return;
                this.currentAssignedDevicesTake += Constants.DEFAULT_TAKE;
                this.searchAndFilterAssignedDevices();
                break;
            default:
                break;
        }
    }

    getSelectedEmployeeDetails(employeeId) {
        const url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_EMPLE_M}?employeeId=${employeeId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    const firstEmployee = responseData.data[0];
                    firstEmployee.UserId = this.props.user.userId;
                    this.currentlySelectedEmployeeDetails = this.clone(firstEmployee);
                    this.setState({ selectedEmployeeDetails: firstEmployee, isEditEmployee: true, isManuallyAddedEmployee: firstEmployee.isManuallyAddedEmployee });
                } else {
                    this.setState({ selectedEmployeeDetails: { hireDate: null }, isManuallyAddedEmployee: false });
                }
            }
        });
    }

    getAllEmployees(oneTime = false) {
        const { searchEmployeeText, searchProjectText, searchDivisionText, pagination } = this.state;
        const searchArray = [];

        if (searchEmployeeText) {
            const searchObj = {
                FieldName: Constants.EMPLOYEE_NAME,
                Value: searchEmployeeText
            };
            searchArray.push(searchObj);
        };

        if (searchProjectText) {
            const searchObj = {
                FieldName: Constants.PROJECT_NUMBER,
                Value: searchProjectText
            };
            searchArray.push(searchObj);
        };

        if (searchDivisionText) {
            const searchObj = {
                FieldName: Constants.DIVISION_NAME_SEARCH,
                Value: searchDivisionText
            };
            searchArray.push(searchObj);
        };

        const requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take,
            Status: this.state.employeeStatus
        };

        const url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_A_EMPLE_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    const employeeList = responseData?.data ?? [];
                    this.allEmployees = this.clone(employeeList);
                    const employeeId = employeeList?.length > 0 ? employeeList[0].id : -1;
                    this.setSelectedEmployee(employeeId);
                    this.setState({ employeeList: employeeList, pagination }, () => {
                        if (oneTime) {
                            this.getUnAssignedDevicesForEmployeeModal();
                        }
                    });
                } else {
                    this.setState({ employeeList: [] });
                }
            }
        });
    }

    getDivisionDetails() {
        const url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_EMP_DIVS_DTL}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    const employeeDivisions = responseData?.data?.group?.map(a => ({ key: a.divisionId, value: a.divisionId, text: a.divisionName })) ?? [];
                    this.setState({ employeeDivisions });
                }
            }
        });
    }

    filterAssignedDevicesFromUnAssignedDevices(deviceIds = []) {
        if (!this.fetchedAssignedDevices) {
            this.fetchedAssignedDevices = true;
            this.tempAssignedDeviceIds = this.clone(deviceIds);
        }
        if (!this.fetchedUnAssignedDevices) return;

        const unAssignedDevices = this.allDevices?.filter(a => !this.tempAssignedDeviceIds.includes(a.deviceID)) ?? [];

        unAssignedDevices.forEach(a => {
            this.deviceUnAssignTrackMap.set(a.deviceID, true);
            this.allUnAssignedDeviceWithoutSlicing.set(a.deviceID, true);
        });

        this.tempAssignedDeviceIds.forEach(a => {
            this.deviceAssignTrackMap.set(a, true);
            this.originalAssignedDevicesMap.set(a, true);
            this.allAssignedDeviceWithoutSlicing.set(a, true);
        });

        this.setState({ unAssignedDevicesInTheDeviceModal: unAssignedDevices?.slice(0, this.currentUnAssignedDevicesTake) });
    }

    searchAndFilterUnAssignedDevices() {
        const text = this.searchUnAssignDeviceText ?? "";

        const devices = this.allDevices
            ?.filter(a => this.deviceUnAssignTrackMap.has(a.deviceID))
            ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(text)
                || a?.projectNumbers.some(b => b?.toLowerCase().includes(text))
                || a?.projectNames.some(b => b?.toLowerCase().includes(text))
            );

        const deviceIds = devices.map(a => a.deviceID);
        this.allUnAssignedDeviceWithoutSlicing.clear();
        deviceIds.forEach(a => this.allUnAssignedDeviceWithoutSlicing.set(a, true));

        const selectAllUnAssignedDevices = deviceIds.length > 0 && deviceIds.every(a => this.state.selectedUnAssignedDevicesMap.has(a));
        this.setState({ unAssignedDevicesInTheDeviceModal: devices.slice(0, this.currentUnAssignedDevicesTake), selectAllUnAssignedDevices });
    }

    searchAndFilterAssignedDevices() {
        const text = this.searchAssignedDeviceText ?? "";

        const devices = this.allDevices
            ?.filter(a => this.deviceAssignTrackMap.has(a.deviceID))
            ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(text)
                || a?.projectNumbers.some(b => b?.toLowerCase().includes(text))
                || a?.projectNames.some(b => b?.toLowerCase().includes(text))
            );

        const deviceIds = devices.map(a => a.deviceID);
        this.allAssignedDeviceWithoutSlicing.clear();
        deviceIds.forEach(a => this.allAssignedDeviceWithoutSlicing.set(a, true));

        const selectAllAssignedDevices = deviceIds.length > 0 && deviceIds.every(a => this.state.selectedAssignedDevicesMap.has(a));
        this.setState({ assignedDevicesInTheDeviceModal: devices.slice(0, this.currentAssignedDevicesTake), selectAllAssignedDevices });
    }

    getAlreadyAssignedDevicesForEmployeePage(scrolling = false) {
        const employeeId = this.getSelectedEmployee().id;
        if (!employeeId) {
            this.setState({ assignedDevicesIntheMainPage: [] });
            return;
        }

        if (scrolling) {
            this.assignedDevicesSkip = this.assignedDevicesTake + this.extraTake;
            this.assignedDevicesTake += Constants.DEFAULT_TAKE;
        }

        const { searchDeviceText } = this.state;
        const searchArray = [];

        if (searchDeviceText) {
            const searchObj = {
                FieldName: Constants.DEVICE_NAME,
                Value: searchDeviceText
            };
            searchArray.push(searchObj);
        };

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray,
            Skip: this.assignedDevicesSkip,
            Take: this.assignedDevicesTake + this.extraTake,
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_EMPLEDEVCE_M}?employeeId=${employeeId}&isFromDeviceSearch=true`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    const data = responseData?.data ?? [];
                    if (scrolling) {
                        const { assignedDevicesIntheMainPage } = this.state;
                        assignedDevicesIntheMainPage.push(...data);
                        this.setState({ assignedDevicesIntheMainPage: assignedDevicesIntheMainPage });
                    } else {
                        this.setState({ assignedDevicesIntheMainPage: data });
                    }
                } else {
                    this.setState({ assignedDevicesIntheMainPage: [] });
                }
            }
        });
    }

    getUnAssignedDevicesForEmployeeModal() {
        const searchArray = [];

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        }, {
            FieldName: Constants.EMPLOYEEPAGE,
            value: ""
        });

        const requestData = {
            SearchText: searchArray,
            Status: Constants.EMP_STATUS_ACTIVE
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_A_DEVCE_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    this.allDevices = responseData?.data ?? [];
                    this.fetchedUnAssignedDevices = true;
                    if (this.fetchedAssignedDevices) {
                        this.filterAssignedDevicesFromUnAssignedDevices();
                    }
                } else {
                    this.allDevices = [];
                }
            }
        });
    }

    getAssignedDevicesForEmployeeModal() {
        const employeeId = this.getSelectedEmployee().id;
        if (!employeeId) {
            return;
        }

        const searchArray = [];

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray,
        };

        const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.GT_EMPLEDEVCE_M}?employeeId=${employeeId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    const devices = responseData?.data ?? [];
                    const deviceIds = devices.map(a => a.deviceID);
                    this.filterAssignedDevicesFromUnAssignedDevices(deviceIds);
                    this.setState({ assignedDevicesInTheDeviceModal: devices?.slice(0, this.currentAssignedDevicesTake) });
                }
            }
        });
    }

    getEmployeeProjectAndDivision() {
        const employeeId = this.getSelectedEmployee()?.id;
        if (!employeeId) {
            this.setState({ selectedEmpProjectAndDivision: { projectNumbers: [], divisions: [] } });
            return;
        }

        const { searchDeviceText } = this.state;
        const searchArray = [];

        if (searchDeviceText) {
            searchArray.push({
                FieldName: Constants.DEVICE_NAME,
                Value: searchDeviceText
            });
        };

        searchArray.push({
            FieldName: Constants.USER_ID,
            value: this.props.user.userId.toString()
        });

        const requestData = {
            SearchText: searchArray
        };

        const url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_EMPLEPRJDIV_M}?employeeId=${employeeId}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    const projectAndDivision = {
                        projectNumbers: responseData?.data?.map(a => a.projectNumber ?? "")?.filter(a => a),
                        divisions: responseData?.data?.map(a => a.division ?? "")?.filter(a => a)
                    };
                    this.setState({ selectedEmpProjectAndDivision: projectAndDivision });
                } else {
                    this.setState({ selectedEmpProjectAndDivision: { projectNumbers: [], divisions: [] } });
                }
            }
        });
    }

    onPageChange(e, { activePage }) {
        const { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({ pagination }, () => {
            this.getAllEmployees();
        });
    }

    onEmployeeSearch(event) {
        this.setState({ searchEmployeeText: event.target.value, pagination: this.getPagination() }, () => {
            this.assignedDevicesSkip = Constants.DEFAULT_SKIP;
            this.assignedDevicesTake = Constants.DEFAULT_TAKE;
            this.resetScrollPosition(Constants.MAIN_EMPLOYEE_SECTION_SCROLL);
            clearTimeout(this.employeeSearchDebounce);
            this.employeeSearchDebounce = setTimeout(() => { this.getAllEmployees() }, 1000);
        });
    }

    onDeviceSearch(event) {
        this.setState({ searchDeviceText: event.target.value }, () => {
            clearTimeout(this.deviceNameSearchDebounce);
            this.assignedDevicesSkip = Constants.DEFAULT_SKIP;
            this.assignedDevicesTake = Constants.DEFAULT_TAKE;
            this.resetScrollPosition(Constants.MAIN_EMPLOYEE_SECTION_SCROLL);
            this.deviceNameSearchDebounce = setTimeout(() => { this.getAlreadyAssignedDevicesForEmployeePage() }, 1000);
        });
    }

    onProjectSearch(event) {
        this.setState({ searchProjectText: event.target.value, pagination: this.getPagination() }, () => {
            clearTimeout(this.projectNameSearchDebounce);
            this.projectNameSearchDebounce = setTimeout(() => { this.getAllEmployees() }, 1000);
        });
    }

    onDivisionSearch(event) {
        this.setState({ searchDivisionText: event.target.value, pagination: this.getPagination() }, () => {
            clearTimeout(this.divisionNameSearchDebounce);
            this.divisionNameSearchDebounce = setTimeout(() => { this.getAllEmployees() }, 1000);
        });
    }

    onUnAssignDeviceSearch(event) {
        this.searchUnAssignDeviceText = event?.target?.value?.toLowerCase() ?? "";
        this.currentUnAssignedDevicesTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.unAssignDeviceSearchDebounce);
        this.unAssignDeviceSearchDebounce = setTimeout(() => { this.searchAndFilterUnAssignedDevices() }, 1000);
    }

    onAssignedDeviceSearch(event) {
        this.searchAssignedDeviceText = event?.target?.value?.toLowerCase() ?? "";
        this.currentAssignedDevicesTake = Constants.DEFAULT_TAKE;
        clearTimeout(this.assignDeviceSearchDebounce);
        this.assignDeviceSearchDebounce = setTimeout(() => { this.searchAndFilterAssignedDevices() }, 1000);
    }

    setSelectedEmployee(employeeId, apiRequest = true) {
        this.currentlySelectedEmployee = employeeId === -1 ? null : this.allEmployees?.find(a => a.id === employeeId) ?? null;
        this.setState({ selectedEmployee: this.currentlySelectedEmployee });
        this.assignedDevicesSkip = Constants.DEFAULT_SKIP;
        this.assignedDevicesTake = Constants.DEFAULT_TAKE;
        this.resetScrollPosition(Constants.MAIN_EMPLOYEE_SECTION_SCROLL);
        if (apiRequest) {
            this.getAlreadyAssignedDevicesForEmployeePage();
            this.getEmployeeProjectAndDivision();
        }
    }

    getSelectedEmployee() {
        return this.currentlySelectedEmployee ?? { id: null };
    }

    handleChange(event) {
        this.setState({
            employeeStatus: event.target.value,
            option: event.target.name,
            pagination: this.getPagination(),
            searchDeviceText: "",
            searchEmployeeText: "",
            searchProjectText: "",
            searchDivisionText: "",
            assignedDevicesIntheMainPage: [],
        }, () => {
            this.getAllEmployees();
        });
    }

    formSubmit(event) {
        const { selectedEmployeeDetails, isManuallyAddedEmployee, isAddEmployee, employeeList } = this.state;

        if (selectedEmployeeDetails.isManagerAccessEnabled && !selectedEmployeeDetails.emailAddress) {
            MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_EMAIL, Constants.ERROR);
            return;
        }

        let isValidMail = true;
        if (selectedEmployeeDetails.emailAddress) {
            isValidMail = emailValidation(selectedEmployeeDetails.emailAddress)
        }

        if (isValidMail) {
            if (isAddEmployee || isManuallyAddedEmployee) {
                if (!selectedEmployeeDetails.fullName) {
                    MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_NAME, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.employeeNumber) {
                    MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_NUMBER, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.employeeStatusFlag) {
                    MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_STATUS, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.jobTitle) {
                    MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_TITLE, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.hireDate) {
                    MessageBox(Constants.PLEASE_ENTER_HIRE_DATE, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.divisionId) {
                    MessageBox(Constants.PLEASE_ENTER_DIVISION, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.unionNumber) {
                    MessageBox(Constants.PLEASE_ENTER_UNION_NUMBER, Constants.ERROR);
                    return;
                }
                if (!selectedEmployeeDetails.projectNumber) {
                    MessageBox(Constants.PLEASE_ENTER_PROJECT_NUMBER, Constants.ERROR);
                    return;
                }
            }
            this.saveEmployeeDetails(selectedEmployeeDetails);
        } else {
            return MessageBox(Constants.PLEASE_ENTER_VALID_EMAIL, Constants.ERROR);
        }
    }

    saveEmployeeDetails(employeeDetails) {
        if (isTwoObjectSame(this.currentlySelectedEmployeeDetails, employeeDetails)) {
            MessageBox(Constants.SAVED_SUCCESSFULLY, Constants.SUCCESS);
            this.resetAll();
        } else {
            this.setState({ isSaveBtnDisabled: true }, () => {
                const url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.UT_EMPLE_M}`;
                employeeDetails.UserId = this.props.user.userId;
                Api.Post(url, employeeDetails, this).then((responseData) => {
                    if (responseData && responseData.success) {
                        this.getAllEmployees();
                        this.setState({ isEditEmployee: false, isAddEmployee: false, selectedEmployeeDetails: { hireDate: null }, isManuallyAddedEmployee: false, isSaveBtnDisabled: false });
                    } else {
                        this.setState({ isSaveBtnDisabled: false });
                    }
                    MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                });
            });
        }
    }

    handleManagerAccessChange(value) {
        const { selectedEmployeeDetails } = this.state;
        selectedEmployeeDetails.isManagerAccessEnabled = value;
        this.setState({ selectedEmployeeDetails });
    }

    handleFormChange(e, { name, value }) {
        const { selectedEmployeeDetails } = this.state;
        if (name && selectedEmployeeDetails) {
            switch (name) {
                case "employeeName":
                    selectedEmployeeDetails.fullName = value;
                    break;
                case "employeeNumber":
                    selectedEmployeeDetails.employeeNumber = value;
                    break;
                case "status":
                    selectedEmployeeDetails.employeeStatusFlag = value;
                    break;
                case "employeeTitle":
                    selectedEmployeeDetails.jobTitle = value;
                    break;
                case "employeeEmailAddress":
                    selectedEmployeeDetails.emailAddress = value;
                    break;
                case "divisionId":
                    selectedEmployeeDetails.divisionId = value;
                    break;
                case "unionNumber":
                    selectedEmployeeDetails.unionNumber = value;
                    break;
                case "projectNumber":
                    selectedEmployeeDetails.projectNumber = value;
                    break;
                default:
                    break;
            }
        }

        this.setState({ selectedEmployeeDetails });
    }

    handleDateChange(date) {
        const { selectedEmployeeDetails } = this.state;
        if ((new Date(date) !== "Invalid Date") && !isNaN(new Date(date))) {
            const dateString = date.toLocaleDateString("en-US");
            const splitDate = dateString.split(" ")[0];
            selectedEmployeeDetails.hireDate = moment(splitDate).format("MM/DD/YYYY");
            this.setState({ selectedEmployeeDetails });
        }
    }

    renderOptions() {
        return this.getStatusOptions().map((data, i) => {
            return (
                <MenuItem label="Status" value={data.value} key={i} option={data.option}>{data.option}</MenuItem>
            );
        });
    }

    onOpenModal({ employeeId = 0, edit = false } = {}) {
        if (edit) {
            this.getSelectedEmployeeDetails(employeeId);
        } else {
            this.setState({ isEditEmployee: true, isAddEmployee: true, selectedEmployeeDetails: { hireDate: null } });
        }
    }

    onCloseModal() {
        this.setState({
            isEditEmployee: false,
            isAddEmployee: false,
            selectedEmployeeDetails: { hireDate: null },
            isManuallyAddedEmployee: false
        }, () => {
            this.getAllEmployees()
        });
    }

    editAssignDevices({ modalOpen, employeeId }) {
        if (modalOpen) {
            this.assignUnAssignAbortController = new AbortController();
            this.setSelectedEmployee(employeeId, false);
            this.setState({ isEditAssignDevices: true }, () => {
                this.getAssignedDevicesForEmployeeModal();
            });
        } else {
            if (this.assignUnAssignAbortController) {
                this.assignUnAssignAbortController.abort();
            }
            this.resetAll();
        }
    }

    resetAll() {
        this.searchUnAssignDeviceText = "";
        this.searchAssignedDeviceText = "";

        this.fetchedAssignedDevices = false;
        this.tempAssignedDeviceIds = [];

        this.currentUnAssignedDevicesTake = Constants.DEFAULT_TAKE;
        this.currentAssignedDevicesTake = Constants.DEFAULT_TAKE;
        this.deviceUnAssignTrackMap.clear();
        this.deviceAssignTrackMap.clear();
        this.originalAssignedDevicesMap.clear();
        this.allUnAssignedDeviceWithoutSlicing.clear();
        this.allAssignedDeviceWithoutSlicing.clear();

        this.currentlySelectedEmployeeDetails = null;
        this.setState({
            isEditAssignDevices: false,
            isSaveBtnDisabled: false,

            isEditEmployee: false,
            isAddEmployee: false,
            selectedEmployeeDetails: { hireDate: null },
            isManuallyAddedEmployee: false,

            // UNASSIGNED
            unAssignedDevicesInTheDeviceModal: [],
            selectedUnAssignedDevicesMap: new Map(),
            selectAllUnAssignedDevices: false,

            // ASSIGNED
            assignedDevicesInTheDeviceModal: [],
            selectedAssignedDevicesMap: new Map(),
            selectAllAssignedDevices: false,
        }, () => {
            this.getAlreadyAssignedDevicesForEmployeePage();
            this.getEmployeeProjectAndDivision();
        });
    }

    assignOrUnassignDevices(isForAssign) {
        const { selectedAssignedDevicesMap, selectedUnAssignedDevicesMap } = this.state;
        if (selectedAssignedDevicesMap.size === 0 && selectedUnAssignedDevicesMap.size === 0) return;

        const unAssignDeviceSearchText = this.searchUnAssignDeviceText ?? "";
        const assignDeviceSearchText = this.searchAssignedDeviceText ?? "";

        if (isForAssign) {
            const goingToAssignDevices = this.allDevices
                ?.filter(a => selectedUnAssignedDevicesMap.has(a.deviceID));

            if (goingToAssignDevices.length > 0) {
                this.currentAssignedDevicesTake = Constants.DEFAULT_TAKE;
                this.currentUnAssignedDevicesTake = Constants.DEFAULT_TAKE;

                goingToAssignDevices.forEach(a => {
                    selectedUnAssignedDevicesMap.delete(a.deviceID);
                    this.deviceAssignTrackMap.set(a.deviceID, true);
                    this.deviceUnAssignTrackMap.delete(a.deviceID);
                    this.allUnAssignedDeviceWithoutSlicing.delete(a.deviceID);
                });

                const newUnAssignedDevicesForEmpModal = this.allDevices
                    ?.filter(a => this.deviceUnAssignTrackMap.has(a.deviceID))
                    ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(unAssignDeviceSearchText)
                        || a?.projectNumbers.some(b => b?.toLowerCase().includes(unAssignDeviceSearchText))
                        || a?.projectNames.some(b => b?.toLowerCase().includes(unAssignDeviceSearchText))
                    );

                const newAssignedDevicesForEmpModal = this.allDevices
                    ?.filter(a => this.deviceAssignTrackMap.has(a.deviceID))
                    ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(assignDeviceSearchText)
                        || a?.projectNumbers.some(b => b?.toLowerCase().includes(assignDeviceSearchText))
                        || a?.projectNames.some(b => b?.toLowerCase().includes(assignDeviceSearchText))
                    );

                const assignedDeviceIds = newAssignedDevicesForEmpModal.map(a => a.deviceID);
                assignedDeviceIds.forEach(a => this.allAssignedDeviceWithoutSlicing.set(a, true));
                this.resetScrollPosition(Constants.MODAL_EMPLOYEE_SECTION_SCROLL);
                this.setState({
                    selectedAssignedDevicesMap,
                    selectedUnAssignedDevicesMap,
                    assignedDevicesInTheDeviceModal: newAssignedDevicesForEmpModal.slice(0, this.currentAssignedDevicesTake),
                    unAssignedDevicesInTheDeviceModal: newUnAssignedDevicesForEmpModal.slice(0, this.currentUnAssignedDevicesTake),
                    selectAllAssignedDevices: assignedDeviceIds.length > 0 && assignedDeviceIds.every(a => selectedAssignedDevicesMap.has(a)),
                    selectAllUnAssignedDevices: false
                });
            }
        } else {
            const goingToUnAssignDevices = this.allDevices
                ?.filter(a => selectedAssignedDevicesMap.has(a.deviceID));

            if (goingToUnAssignDevices.length > 0) {
                this.currentAssignedDevicesTake = Constants.DEFAULT_TAKE;
                this.currentUnAssignedDevicesTake = Constants.DEFAULT_TAKE;

                goingToUnAssignDevices.forEach(a => {
                    selectedAssignedDevicesMap.delete(a.deviceID);
                    this.deviceUnAssignTrackMap.set(a.deviceID, true);
                    this.deviceAssignTrackMap.delete(a.deviceID);
                    this.allAssignedDeviceWithoutSlicing.delete(a.deviceID);
                });

                const newUnAssignedDevicesForEmpModal = this.allDevices
                    ?.filter(a => this.deviceUnAssignTrackMap.has(a.deviceID))
                    ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(unAssignDeviceSearchText)
                        || a?.projectNumbers.some(b => b?.toLowerCase().includes(unAssignDeviceSearchText))
                        || a?.projectNames.some(b => b?.toLowerCase().includes(unAssignDeviceSearchText))
                    );

                const newAssignedDevicesForEmpModal = this.allDevices
                    ?.filter(a => this.deviceAssignTrackMap.has(a.deviceID))
                    ?.filter(a => a?.deviceEmpID?.toLowerCase()?.includes(assignDeviceSearchText)
                        || a?.projectNumbers.some(b => b?.toLowerCase().includes(assignDeviceSearchText))
                        || a?.projectNames.some(b => b?.toLowerCase().includes(assignDeviceSearchText))
                    );

                const unAssignedDeviceIds = newUnAssignedDevicesForEmpModal.map(a => a.deviceID);
                unAssignedDeviceIds.forEach(a => this.allUnAssignedDeviceWithoutSlicing.set(a, true));
                this.resetScrollPosition(Constants.MODAL_EMPLOYEE_SECTION_SCROLL);
                this.setState({
                    selectedAssignedDevicesMap,
                    selectedUnAssignedDevicesMap,
                    assignedDevicesInTheDeviceModal: newAssignedDevicesForEmpModal.slice(0, this.currentAssignedDevicesTake),
                    unAssignedDevicesInTheDeviceModal: newUnAssignedDevicesForEmpModal.slice(0, this.currentUnAssignedDevicesTake),
                    selectAllAssignedDevices: false,
                    selectAllUnAssignedDevices: unAssignedDeviceIds.length > 0 && unAssignedDeviceIds.every(a => selectedUnAssignedDevicesMap.has(a))
                });
            }
        }
    }

    selectOrUnSelectAllAssignedDevices(e, value) {
        const { selectedAssignedDevicesMap } = this.state;
        let checked = value?.checked ?? false;

        if (this.allAssignedDeviceWithoutSlicing.size === 0) checked = false;
        if (checked) {
            this.allAssignedDeviceWithoutSlicing.forEach((v, k) => selectedAssignedDevicesMap.set(k, v));
        } else {
            this.allAssignedDeviceWithoutSlicing.forEach((_, k) => selectedAssignedDevicesMap.delete(k));
        }

        this.setState({ selectedAssignedDevicesMap, selectAllAssignedDevices: checked });
    }

    selectOrUnSelectAllUnAssignedDevices(e, value) {
        const { selectedUnAssignedDevicesMap } = this.state;
        let checked = value?.checked ?? false;

        if (this.allUnAssignedDeviceWithoutSlicing.size === 0) checked = false;
        if (checked) {
            this.allUnAssignedDeviceWithoutSlicing.forEach((v, k) => selectedUnAssignedDevicesMap.set(k, v));
        } else {
            this.allUnAssignedDeviceWithoutSlicing.forEach((_, k) => selectedUnAssignedDevicesMap.delete(k));
        }

        this.setState({ selectedUnAssignedDevicesMap, selectAllUnAssignedDevices: checked });
    }

    addOrRemoveSelectedUnAssignedDevice(deviceId) {
        const { selectedUnAssignedDevicesMap, unAssignedDevicesInTheDeviceModal } = this.state;
        const deviceIds = unAssignedDevicesInTheDeviceModal.map(a => a.deviceID);

        if (selectedUnAssignedDevicesMap.has(deviceId)) {
            selectedUnAssignedDevicesMap.delete(deviceId);
        } else {
            selectedUnAssignedDevicesMap.set(deviceId, true);
        }

        this.setState({ selectedUnAssignedDevicesMap, selectAllUnAssignedDevices: deviceIds.every(a => selectedUnAssignedDevicesMap.has(a)) });
    }

    addOrRemoveSelectedAssignedDevice(deviceId) {
        const { selectedAssignedDevicesMap, assignedDevicesInTheDeviceModal } = this.state;
        const deviceIds = assignedDevicesInTheDeviceModal.map(a => a.deviceID);

        if (selectedAssignedDevicesMap.has(deviceId)) {
            selectedAssignedDevicesMap.delete(deviceId);
        } else {
            selectedAssignedDevicesMap.set(deviceId, true);
        }

        this.setState({ selectedAssignedDevicesMap, selectAllAssignedDevices: deviceIds.every(a => selectedAssignedDevicesMap.has(a)) });
    }

    saveAssignOrUnassignDevices() {
        const employeeId = this.getSelectedEmployee().id;
        if (!employeeId) return;

        const orginalAssignedDeviceIds = [...this.originalAssignedDevicesMap.keys()];
        const assignedDeviceIds = [...this.deviceAssignTrackMap.keys()];
        const devicesChanged = orginalAssignedDeviceIds.length !== assignedDeviceIds.length || !orginalAssignedDeviceIds.every(a => assignedDeviceIds.includes(a));

        if (devicesChanged) {
            const devices = [];

            const deletedAssignedDevices = orginalAssignedDeviceIds.filter(a => !this.deviceAssignTrackMap.has(a));
            const newlyAssignedDevices = assignedDeviceIds.filter(a => !this.originalAssignedDevicesMap.has(a));

            deletedAssignedDevices.forEach(a => devices.push({ deviceId: a, status: "deleted" }));
            newlyAssignedDevices.forEach(a => devices.push({ deviceId: a, status: "new" }));

            this.setState({ isSaveBtnDisabled: true }, () => {
                const url = `${ApiUrls.Routes.DEVCE_C}${ApiUrls.Routes.UT_EMPLEDEVCE_M}?employeeId=${employeeId}&modifiedById=${this.props.user.userId}`;
                Api.Post(url, devices, this, this.assignUnAssignAbortController?.signal).then((responseData) => {
                    if (responseData.success) {
                        this.resetAll();
                        this.resetScrollPosition(Constants.MAIN_EMPLOYEE_SECTION_SCROLL);
                    } else {
                        this.setState({ isSaveBtnDisabled: false });
                    }
                    MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                });
            });
        } else {
            MessageBox(Constants.SAVED_SUCCESSFULLY, Constants.SUCCESS);
            this.resetAll();
        }
    }

    resetScrollPosition(type) {
        const scrollConfig = {
            [Constants.MODAL_EMPLOYEE_SECTION_SCROLL]: ["unAssignedDevicesScroll", "assignedDevicesScroll"],
            [Constants.MAIN_EMPLOYEE_SECTION_SCROLL]: ["assignedDevicesScrollForMainPage"]
        };

        const ids = scrollConfig[type] || [];

        ids.forEach(id => {
            const element = document.getElementById(id);
            if (element) element.scrollTop = 0;
        });
    }

    render() {
        const {
            employeeList,
            isAddEmployee,
            employeeStatusOptions,
            searchDeviceText,
            searchEmployeeText,
            searchProjectText,
            searchDivisionText,
            employeeStatus,
            selectedEmployeeDetails,
            isEditEmployee,
            isEditAssignDevices,
            pagination,
            employeeDivisions,
            isManuallyAddedEmployee,
            selectedEmpProjectAndDivision,
            isSaveBtnDisabled,
            assignedDevicesIntheMainPage,
            unAssignedDevicesInTheDeviceModal,
            assignedDevicesInTheDeviceModal,
            selectedUnAssignedDevicesMap,
            selectedAssignedDevicesMap,
            selectAllUnAssignedDevices,
            selectAllAssignedDevices,
        } = this.state;
        return (
            <Fragment>
                <EmployeeComponent
                    {...{
                        employee: {
                            selectedEmployee: this.currentlySelectedEmployee,
                            employeeList,
                            employeeStatus,
                            isEditEmployee,
                            isEditAssignDevices,
                            selectedEmployeeDetails,
                            pagination,
                            employeeStatusOptions,
                            employeeDivisions,
                            searchDeviceText,
                            searchEmployeeText,
                            searchProjectText,
                            searchDivisionText,
                            isManuallyAddedEmployee,
                            isAddEmployee,
                            selectedEmpProjectAndDivision,
                            isSaveBtnDisabled,

                            assignedDevicesIntheMainPage,
                            unAssignedDevicesInTheDeviceModal,
                            assignedDevicesInTheDeviceModal,
                            selectedUnAssignedDevicesMap,
                            selectedAssignedDevicesMap,
                            selectAllUnAssignedDevices,
                            selectAllAssignedDevices,
                        }
                    }}
                    renderOptions={this.renderOptions.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    onOpenModal={this.onOpenModal.bind(this)}
                    onCloseModal={this.onCloseModal.bind(this)}
                    editAssignDevices={this.editAssignDevices.bind(this)}
                    formSubmit={this.formSubmit.bind(this)}
                    handleFormChange={this.handleFormChange.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    user={this.props.user}

                    onEmployeeSearch={this.onEmployeeSearch.bind(this)}
                    onDeviceSearch={this.onDeviceSearch.bind(this)}
                    onUnAssignDeviceSearch={this.onUnAssignDeviceSearch.bind(this)}
                    onAssignedDeviceSearch={this.onAssignedDeviceSearch.bind(this)}
                    onProjectSearch={this.onProjectSearch.bind(this)}
                    onDivisionSearch={this.onDivisionSearch.bind(this)}

                    setSelectedEmployee={this.setSelectedEmployee.bind(this)}
                    assignOrUnassignDevices={this.assignOrUnassignDevices.bind(this)}
                    saveAssignOrUnassignDevices={this.saveAssignOrUnassignDevices.bind(this)}
                    selectOrUnSelectAllUnAssignedDevices={this.selectOrUnSelectAllUnAssignedDevices.bind(this)}
                    selectOrUnSelectAllAssignedDevices={this.selectOrUnSelectAllAssignedDevices.bind(this)}
                    handleManagerAccessChange={this.handleManagerAccessChange.bind(this)}
                    handleDateChange={this.handleDateChange.bind(this)}
                    addOrRemoveSelectedUnAssignedDevice={this.addOrRemoveSelectedUnAssignedDevice.bind(this)}
                    addOrRemoveSelectedAssignedDevice={this.addOrRemoveSelectedAssignedDevice.bind(this)}
                    fetchNext={this.fetchNext.bind(this)}
                    getAlreadyAssignedDevicesForEmployeePage={this.getAlreadyAssignedDevicesForEmployeePage.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Employee));

Employee.displayName = 'Employee';